import { _findErrors } from './_findErrors';
import { _findScheduleReport } from './_findScheduleReport';
import { _findSchedulePending } from './_findSchedulePending';
import { _findVisitScheduleReference } from './_findVisitScheduleReference';
import { _updateSchedulingEvents } from './_updateSchedulingEvents';

class DailySchedule {
  _dailySchedules;

  constructor(dailySchedules) {
    this._dailySchedules = dailySchedules;
  }

  changeFromForm(dailyScheduleForm, padVisit) {
    return [...this._dailySchedules].map(dailySchedule => {
      const { /* padVisit, schedulingEvents, */ visitScheduleReference } = dailySchedule;

      if (dailySchedule.padVisit.id !== padVisit.id) {
        return dailySchedule;
      }

      const updatedSchedulingEvents = _updateSchedulingEvents(dailyScheduleForm, dailySchedule);

      const scheduleErrors = _findErrors(updatedSchedulingEvents, padVisit);

      const { isScheduleComplete, scheduleReport } = _findScheduleReport(
        updatedSchedulingEvents,
        visitScheduleReference
      );

      const schedulePendings = _findSchedulePending(scheduleReport);

      return {
        ...dailySchedule,
        isScheduleComplete,
        scheduleReport,
        scheduleErrors,
        schedulePendings,
        schedulingEvents: [...updatedSchedulingEvents]
      };
    });
  }

  changeFromHospitalDischarge(hospitalReleasePrevision) {
    return [...this._dailySchedules].map(dailySchedule => {
      const { padVisit } = dailySchedule;

      const { pad, frequencyAmount, totalAmount } = padVisit;
      const { startDate, endDate } = pad;

      const visitScheduleReference = _findVisitScheduleReference({
        startDate,
        endDate,
        frequencyAmount,
        totalAmount,
        hospitalReleasePrevision
      });

      return {
        ...dailySchedule,
        visitScheduleReference
      };
    });
  }
}

export { DailySchedule };
